<template>
  <div class="xcard" style="position:relative">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras...</v-btn>    
    <h3 class="text-center" style="margin-top:0"> Inscripciones del programa </h3>
    <p class="text-center text-primary" style="margin-bottom:0"> {{pro}} </p>
    <button v-show="inscripciones.length > 0" class="btn btn-sm btn-link" @click="tableToExcel('table', 'Lorem Table')"> <span class="glyphicon glyphicon-print"></span> Generar Reporte EXCEL </button>
    <div>
      <p class="text-primary"> {{msg}} </p>
      <table ref="table" class="table table-condensed table-striped table-hover" summary="lorem ipsum sit amet" rules="groups" frame="hsides">
        <caption v-show="false">Reporte de Inscripciones a el programa: {{pro}} </caption>
        <thead>
          <tr>
            <th>Nro</th>
            <th>Estudiante</th>
            <th>Documento</th>
            <th>Correo</th>

            <th style="background:#C8FFB8" >Matricula</th>
            <th style="background:#C8FFB8" >Saldo</th>
            <th style="background:#EFFFB8" >Colegiatura</th>
            <th style="background:#EFFFB8" >Saldo</th>
            <th style="background:#D9F0D9" >Certificacion</th>

            <th style="background:#D9F0D9" >Saldo</th>
            <th>Estado</th>
            <th style="min-width:120px">Opciones</th>
          </tr>
        </thead>

        <tbody> 
          <tr v-bind:key="ins.id" v-for="(ins,ind) in inscripciones">
            <td> {{ ind+1 }} </td>
            <td> {{ parseEstudiante(ins.estudiante) }} </td>
            <td> {{ parseDoc(ins.estudiante) }} </td>
            <td> {{ parseCorreo(ins.estudiante) }} </td>

            <td style="background:#C8FFB8" > {{ ins.monto_matricula }} </td>

            <td style="background:#C8FFB8" > {{ ins.matricula }} </td>

            <td style="background:#EFFFB8" > {{ ins.monto_colegiatura }} </td>

            <td style="background:#EFFFB8" > {{  ins.saldo_colegiatura }} </td>

            <td style="background:#D9F0D9" > {{  ins.monto_certificacion }} </td>
            
            <td style="background:#D9F0D9" > {{  ins.saldo_certificacion }} </td>

            <td :style="parseInsColor(ins.estado_ins)"> {{ parseIns(ins.estado_ins) }} </td>
            <td>
              <button class="btn btn-sm btn-default" title="Ver Detalles" @click="verDetalles(ins.id)" data-toggle="modal" data-target="#modal"> 
                <span class="glyphicon glyphicon-eye-open"></span>
              </button>

              <!-- <button v-if="ins.estado_ins" v-show="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14" class="btn btn-sm btn-default" title="Pagos" @click="pagos(ins.id)" data-toggle="modal" data-target="#modal"> 
                <span class="glyphicon glyphicon-credit-card"></span>
              </button> -->
            </td>
          </tr>
          
          <tr v-if="verPagos">
            <td colspan="4"></td>
            <td class="text-primary"> <small> {{ numberWithCommas(total_matricula) }} <br/> Bs. </small> </td>
            <td class="text-primary"> <small> {{ numberWithCommas(total_matrisaldo) }} <br/> Bs. </small> </td>
            <td class="text-primary"> <small> {{ numberWithCommas(total_colegiatura) }} <br/> Bs. </small> </td>
            <td class="text-primary"> <small> {{ numberWithCommas(total_colegiasaldo) }} <br/> Bs. </small> </td>
            <td class="text-primary"> <small> {{ numberWithCommas(total_certificacion) }} <br/> Bs. </small> </td>
            <td class="text-primary"> <small> {{ numberWithCommas(total_certificasaldo) }} <br/> Bs. </small> </td>
            <td colspan="2"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <Alertas ref="xalertar" />
    <notifications group="auth" position="bottom right" />

    <Detalle id="modal" v-bind:obj="seleccionado" v-on:exito="modalExito" />
  </div>
</template>

<script>
import Detalle from '@/components/ADetalleInscrito'
import { parseJsonError } from '@/components/Utils.js'
import Alertas from '@/components/AAlertas.vue'
import gql from 'graphql-tag'

  export default {
    data(){
      return{
        // EXCEL 
        uri :'data:application/vnd.ms-excel;base64,',
        template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
        format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) },
        // END EXCEL
        seleccionado: {xid:-1,xtitle:'X',xbody:'X',xsql:null},
        verPagos: true,
        msg:'Cargando....',
        pro: '',
        idprograma: {},
        pagarMatricula:{ id:-1 },
        inscripciones:[],

        
        total_matricula: 0,
        total_matrisaldo: 0,
        total_colegiatura: 0,
        total_colegiasaldo: 0,
        total_certificacion: 0,
        total_certificasaldo: 0,
        
      }
    },
    components:{ Alertas,Detalle },
    watch:{
      '$store.state.CARGO': function(){
        window.console.log( "JEJEJEEJEJ ----\n",this.$store.state.CARGO )
      }
    },
    methods:{
      /*verPagss(){
        this.verPagos = !this.verPagos;
        this.total_matricula = 0;
        this.total_matrisaldo = 0;
        this.total_colegiatura = 0;
        this.total_colegiasaldo = 0;
        this.total_certificacion = 0;
        this.total_certificasaldo = 0;
      },*/
      tableToExcel(table, name){
        if (!table.nodeType) table = this.$refs.table
        var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
        var link = document.createElement("a");
        link.download = "reporte_programa.xls";
        link.href = this.uri + this.base64(this.format(this.template, ctx));
        link.click();
      },
      modalExito(){},
      parseDoc( u ){
        if( u == null ) return "";
        if( u.departamento != null ) return u.num_doc +" "+u.departamento.extension;
        return u.num_doc;
      },
      parseCorreo( u ){
        if( u == null ) return "";
        return u.email;
      },
      parseTelefono( u ){
        if( u == null ) return "";
        return u.telefono1;
      },
      parseLogin( u ){
        if( u == null ) return "";
        return u.usuario_moodle;
      },
      parseClave( u ){
        if( u == null ) return "";
        return u.clave_moodle;
      },
      parsePrograma( p ){
        if( p == null ) return "";
        var cate ="";
        var post = "";
        if( p.postgrado.categoria != null  ) cate = p.postgrado.categoria.nombre;
        if( p.postgrado != null  ) post = p.postgrado.nombre;
        return cate+" - "+post+" version:"+p.version+", gestion:"+p.gestion;
      },
      parseEstudiante( e ){
        if( e == null ) return "";
        var seg = e.seg_apellido;
        if( seg == null ) seg = "";
        return e.nombres+" "+e.pri_apellido+" "+seg;
      },
      parseSede( p ){
        if( p == null ) return "";
        if( p.sede == null  ) return "-";
        return p.sede.nombre;
      },
      parseFecha( f ){
        var date = new Date( f );
        var a = date.getFullYear();
        var m = date.getMonth()+1;
        var d = date.getDate();
        if( m < 10 ) m = '0'+m;
        if( d < 10 ) d = '0'+d;
        return d+'-'+m+'-'+a;
      },
      parseIns( ins ){
        if( ins == 0 ) return "Pre inscrito";
        else if( ins == 1 ) return "Inscrito";
        else return " "+ins;
      },
      parseInsColor( ins ){
        if( ins == 0 ) return "background:#EFFFA8";
        else if( ins == 1 ) return "background:#A8FFA8";
        else if( ins == 2 ) return "background:#D9F0D9";
        else if( ins == 3 ) return "background:#FFC8A8";
        else return "";
      },
      debeMatricula( m ){
        var b = false;
        if( m == null ) b =  false;
        else if( !m.puede_pagar ) b =  false;
        else if( m.saldo > 0 ) b =  true;
        return b;
      },
      debeCuota( cuotas ){
        if( cuotas == null ) return false;
        if( cuotas.length == 0 ) return true;
        var cuota = cuotas[0];
        if( !cuota.puede_pagar ) return false;
        if( cuota.saldo > 0 ) return true;
        return false;
      },
      validarDatos(){
        if( this.idprograma == null ) return;
        this.buscarInscripciones();
      },
      verDetalles( id ){
        window.console.log( "ID DETALLE: ",id );
        var msg = "Detalle de la inscripcion";
        var body = "Detalles";
        var tag = gql`
        query{
          getInscripcion(id:${id}){
            id,estado_ins,observaciones,fecha_registro,matricula{monto,saldo},
            monto_colegiatura,monto_certificacion, 
            cuotas,lista_cuotas{monto,saldo,fecha},certificacion{monto,saldo}
          }
        }
        `;
        this.seleccionado = {xid:12,xtitle:msg,xbody:body,xsql:tag}
      },
      whatsapp( tel ){
        window.open( `${process.env.VUE_APP_API_WHATSAPP}591`+tel+"&text=Hola");
      },
      pagos( id ){
        window.sessionStorage.setItem( 'xins',JSON.stringify(id) );
        window.sessionStorage.setItem( 'routerTo',"programains" );
        this.$router.push({name:'pagos'});
      },
      buscarInscripciones(){
        this.$refs.xalertar.cargando();
        var vue = this;
        var sql = gql`query{ getPrograma(id:${this.idprograma}){inscripciones{id,estado_ins,fecha_registro,estudiante{email,num_doc,telefono1,usuario_moodle,clave_moodle,nombres,pri_apellido,seg_apellido,departamento{extension}},asesor{num_doc,num_doc,nombres,pri_apellido,seg_apellido},programa{id,version,grupo,fecha_inicio,fecha_fin,sede{nombre},postgrado{nombre,categoria{nombre}}}}}}`;
        vue.msg = '';
        window.console.log( sql );

        this.$apollo.query({
          query: sql,
        }).then((data) => {
            vue.inscripciones = data.data.getPrograma.inscripciones;
            vue.inscripciones.forEach( function(e){
              e.monto_matricula = vue.getMontoMatricula(e.monto_matricula);
              e.matricula = vue.getSaldoMatricula(e.matricula);
            })
            this.msg = this.inscripciones.length+' inscripciones.';
            this.$refs.xalertar.reset();
        }).catch((error) => {
          this.msg = error;
          window.console.error(error)
          this.$notify( parseJsonError( error,'getPrograma' ) )
        })

      },
      getMontoMatricula( m ){
        if( m == null ) return 0;
        this.total_matricula += m;
        return m;
      },
      getSaldoMatricula( m ){
        if( m == null ) return 0;
        this.total_matrisaldo += m.saldo;
        return m.saldo;
      },
      getMontoColegiatura( c ){
        if( c == null ) return 0;
        this.total_colegiatura += c;
        return c;
      },
      getSaldoColegiatura( cole,l ){
        var monto = 0;
        l.forEach( function(e){
          monto += (e.monto-e.saldo);
        })
        this.total_colegiasaldo += (cole-monto);
        return cole-monto;
      },
      getMontoCertificacion( c ){
        if( c == null ) return 0;
        this.total_certificacion += c;
        return c;
      },
      getSaldoCertificacion( cert,e ){
        if( e == null ) return 0;
        var monto = (e.monto-e.saldo);
        this.total_certificasaldo += (cert-monto);
        return cert-monto;
      },
      numberWithCommas(x) {
        if( x == null ) return "0"
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    mounted(){
      var xp = window.sessionStorage.xprograma;
      if( xp ) {
        var p = JSON.parse( xp );
        if( p ){
          this.pro = this.parsePrograma( p ) ;
          this.idprograma = p.id;
        } 
      }
      this.validarDatos()
    }
  }
</script>